import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';

// Simple wrapper functions
export function lockScroll(element) {
	if (!element) return;
	disableBodyScroll(element);
}

export function unlockScroll(element) {
	if (!element) return;
	enableBodyScroll(element);
}

export function unlockAll() {
	clearAllBodyScrollLocks();
}

// Export original functions too if needed
export { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks };
